import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";
import Alert from "../../icons/alert";
import __ from "../../utils/getContent";

const EmailField = ({
	registeredName,
	label,
	description,
	requiredText,
	isRequired,
	placeholder,
	defaultValue,
	disabled,
	memberEmail,
}: {
	registeredName: string;
	label: string;
	description?: string;
	requiredText: string;
	isRequired?: boolean;
	placeholder: string;
	defaultValue?: string;
	disabled?: boolean;
	memberEmail?: string;
}) => {
	const {
		register,
		setError,
		clearErrors,
		formState: { errors },
	} = useFormContext();

	const disabledClass = disabled ? " bg-gray-200 border-gray-400" : "";
	const cssClass =
		"border border-black w-full py-3 px-2 placeholder:uppercase" +
		disabledClass;

	// Check if the email is already registered.
	function checkDuplicateEmail(value: string) {
		if (!memberEmail) {
			return;
		}
		if (memberEmail === value) {
			// Duplicate email.
			setError(registeredName, {
				type: "custom",
				message: __(
					"input_email_description",
					"All members must have a unique email address.",
				),
			});
		} else {
			// Clear the error if the email is not a duplicate.
			clearErrors(registeredName);
		}
	}

	return (
		<div className="mb-3">
			<label
				className="ml-2 flex text-sm uppercase"
				htmlFor={`input-${registeredName}`}
			>
				{label}
				{isRequired && "*"}
				{description && (
					<span className="ml-2 flex gap-1 text-xs lowercase">
						<Alert size="xs" />
						{description}
					</span>
				)}
			</label>

			{errors && (
				<p className="mb-1 ml-2 text-xs text-red-500">
					<ErrorMessage errors={errors} name={registeredName} />
				</p>
			)}

			<input
				type="email"
				id={`input-${registeredName}`}
				defaultValue={defaultValue || ""}
				placeholder={placeholder}
				{...register(registeredName, {
					pattern: {
						value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
						message: requiredText,
					},
				})}
				onChange={(e) => memberEmail && checkDuplicateEmail(e.target.value)}
				className={cssClass}
				disabled={disabled}
				required={isRequired}
			/>
		</div>
	);
};
export default EmailField;
